import React from "react"
import { navigate } from "gatsby"
import usePrefecturesCollection from "../../../../hooks/usePrefecturesCollection"
import { VaudMap } from "@bw/partials"

const Prefectures = () => {
  const prefectures = usePrefecturesCollection()

  const clickOnMap = React.useCallback(
    e => {
      const prefecture = prefectures.find(
        prefecture => prefecture.district.value === e.target.id
      )

      if (prefecture) {
        navigate(prefecture.url)
      }
    },
    [prefectures]
  )

  return <VaudMap onClick={clickOnMap} />
}
export { Prefectures }
